import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudentWellBeingRoutingModule } from './student-well-being-routing.module';
import { StudentFormComponent } from './student-form/student-form.component';
import { StudentFormLinkComponent } from './student-form-link/student-form-link.component';
import { AcademicFormModule } from '../../academic-form/academic-form.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { StudentwellbeingReportComponent } from './studentwellbeing-report/studentwellbeing-report.component';
import { AgGridModule } from 'ag-grid-angular';
import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { environment } from 'src/environments/environment';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { AssessmentSubmitConfirmComponent } from './assessment-submit-confirm/assessment-submit-confirm.component';
import { FacultyReferralFormComponent } from './faculty-referral-form/faculty-referral-form.component';
import { SingleQuestionDialogComponent } from './single-question-dialog/single-question-dialog.component';
import { WellbeingReferralReportComponent } from './wellbeing-referral-report/wellbeing-referral-report.component';
import { ShowQuestionPaperComponent } from './show-question-paper/show-question-paper.component';

ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey(environment.ag_grid_key);

@NgModule({
  declarations: [
    StudentFormComponent,
    StudentFormLinkComponent,
    StudentwellbeingReportComponent,
    AssessmentSubmitConfirmComponent,
    FacultyReferralFormComponent,
    SingleQuestionDialogComponent,
    WellbeingReferralReportComponent,
    ShowQuestionPaperComponent
  ],
  imports: [
    CommonModule,
    StudentWellBeingRoutingModule,
    AcademicFormModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    MatDialogModule,
    AgGridModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule

  ]
})
export class StudentWellBeingModule { }
